import type { ReceiptTemplate } from '../schema';

export const bpTemplate: ReceiptTemplate = {
  id: 'bp',
  name: 'BP Gas Receipt',
  brand: 'BP',
  description: 'BP gas station receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'bp-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/bp.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 24,
        addressLines: [
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'bp-trans',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: '01/04/2026 2:45 PM\nPUMP #4',
        fontSize: 12,
        showDivider: true,
        dividerStyle: 'dashed',
        isBold: false,
      },
    },
    {
      id: 'bp-fuel',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'product', label: 'UNLEADED PLUS', value: '', isBold: false, isLarge: false },
          { id: 'gallons', label: 'GALLONS', value: '12.547', isBold: false, isLarge: false },
          { id: 'ppg', label: 'PRICE/GAL', value: '3.899', isBold: false, isLarge: false },
          { id: 'total', label: 'FUEL TOTAL', value: '48.92', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'bp-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'VISA ****4144',
        fields: [
          { id: 'auth', label: 'AUTH:', value: '059746' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'bp-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'BP REWARDS MEMBER\n\nTHANK YOU\nPLEASE COME AGAIN',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

